export default __webpack_public_path__ + "static/media/field-notes-empty-state.65a2bdfb.png";